const courseExamAndBatchActions = {
    GET_COURSE_BY_DRIVE: 'GET_COURSE_BY_DRIVE',
    SET_COURSE_BY_DRIVE: 'SET_COURSE_BY_DRIVE',

    CREATE_EXAMDATE: 'CREATE_EXAMDATE',
    CREATE_EXAM_BATCH:'CREATE_EXAM_BATCH',
    EDIT_EXAM_BATCH:'EDIT_EXAM_BATCH',
};

export default courseExamAndBatchActions;